import PatientRegisterForm from "../PageElements/RegistrationPageElements/RegistrationSection"
import ServiceSection from "../PageElements/HomePageElements/ServiceSection"
import ConsultSection from "../PageElements/HomePageElements/ConsultSection";
import RegistrationFirstSection from "../PageElements/RegistrationPageElements/RegistrationFirstSection";

export default function RegistrationPage() {
    return (
        <>
            <RegistrationFirstSection />
            <PatientRegisterForm />
            {/* <ServiceSection /> */}
            <ConsultSection />
        </>
    )
}